// Mixins
import { userMixins } from "@/app/mixins/modules/user-mixins.js"
import { dateMixins } from "@/app/mixins/utils/date-mixins"

const HealthData = () =>
	import(
		/* webpackChunkName: "health-data-component" */ "@/app/views/main-view/_shared/_components/health-data-component/health-data-component.vue"
	)
const SocialClub = () =>
	import(
		/* webpackChunkName: "social-club" */ "@/app/views/main-view/dashboard/components/social-club-dashboard/social-club-dashboard.vue"
	)
const Treatment = () =>
	import(
		/* webpackChunkName: "treatment-component" */ "@/app/views/main-view/_shared/_components/treatment-component/treatment-component.vue"
	)
const Timeline = () =>
	import(/* webpackChunkName: "treatment-component" */ "@/app/views/main-view/_shared/timeline/timeline.vue")

// Services
import treatmentService from "@/app/services/main/treatment/treatment-service.js"
import exerciseService from "@/app/services/main/exercise/exercise-service.js"
import reminderService from "@/app/services/main/reminder/reminder-service.js"
import notificationService from "@/app/services/main/notification/notification-service.js"

// Constant
import { STATUS_CODES } from "@/app/constants/status-constants"
import { subMonths, subDays } from "date-fns"

// Mixins
import EventBus from "@/app/bus/event-bus"

export default {
	name: "AuthContainer",
	mixins: [userMixins, dateMixins],
	components: {
		SocialClub,
		Treatment,
		HealthData,
		Timeline,
	},
	data() {
		return {
			dataList: [],
			dateEndsAt: new Date(),
			dateStartsAt: subMonths(new Date(), 1),
		}
	},
	watch: {
		// 'getActivePet':{
		// 	handler(newVal) {
		// 		if (newVal) {
		// 			this.refreshActivePetData();
		// 		}
		// 	},
		// 	deep: true
		// }
	},
	async created() {
		await this.infiniteHandler()

		EventBus.$on("petSwitched", this.refreshActivePetData)
		window.addEventListener("scroll", this.scrollToTop)
	},
	destroyed() {
		window.removeEventListener("scroll", this.scrollToTop)
	},
	beforeDestroy() {
		EventBus.$off("petSwitched", this.refreshActivePetData)
	},
	methods: {
		scrollToTop() {
			// Get the button
			let btnToTop = document.getElementById("btn-back-to-top")
			if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
				btnToTop.style.display = "flex"
			} else {
				btnToTop.style.display = "none"
			}
		},
		backToTop() {
			document.body.scrollTop = 0
			document.documentElement.scrollTop = 0
		},
		async refreshActivePetData() {
			// Refresh timeline when switched pet
			this.dataList = []
			this.dateEndsAt = new Date()
			this.dateStartsAt = subMonths(new Date(), 1)

			await this.infiniteHandler()
		},
		async infiniteHandler() {
			const date = new Date(this.getActivePet.birthdate)
			if (this.dataList.length > 0) {
				// Add checker if birthday is in between the date of first call
				if (date >= this.dateStartsAt && date <= this.dateEndsAt) {
					if (this.$refs.timeline.$refs.timelineLoader) {
						this.$refs.timeline.$refs.timelineLoader.stateChanger.complete()
					}
				}

				// Infinite load starts here
				// Subtract 1 month and 1 day for the filter
				this.dateEndsAt = subDays(this.dateStartsAt, 1)
				this.dateStartsAt = subMonths(subDays(this.dateStartsAt, 1), 1)

				await this.getInitialLoadTimeline()
			} else {
				this.dateStartsAt = date
				await this.getInitialLoadTimeline()
			}

			// If birthdate is in range of the filter we will stop the infinite loop
			if (date >= this.dateStartsAt && date < this.dateEndsAt) {
				this.addBirthdayToList()
				if (this.$refs.timeline.$refs.timelineLoader) {
					this.$refs.timeline.$refs.timelineLoader.stateChanger.complete()
				}
			} else {
				// Continue to load the api calls
				if (this.$refs.timeline.$refs.timelineLoader) {
					this.$refs.timeline.$refs.timelineLoader.stateChanger.loaded()
				}
			}
		},
		addBirthdayToList() {
			const e = {
				img: this.getActivePet.imageUrl ? this.getActivePet.imageUrl : "",
				time: this.getActivePet.birthdate,
				title: "Birthday",
				content: `${this.getActivePet.name} was born.`,
				class: "is-birthdate",
			}
			this.dataList = this.dataList.concat(e)
			const unique = Array.from(new Set(this.dataList.map(JSON.stringify))).map(JSON.parse)
			this.dataList = unique
		},
		async getInitialLoadTimeline() {
			const e = await this.getExerciseList()
			const t = await this.getTreatmentList()
			const r1 = await this.getReminderList("ACTIVE")
			const r2 = await this.getReminderList("INACTIVE")
			const g = await this.getGeneralInfoList()
			// Merge all list
			this.dataList = this.dataList.concat(g)
			this.dataList = this.dataList.concat(e)
			this.dataList = this.dataList.concat(t)
			this.dataList = this.dataList.concat(r1)
			this.dataList = this.dataList.concat(r2)

			// Sort list by date
			this.dataList = this.dataList.sort(function (a, b) {
				const c = new Date(a.time)
				const d = new Date(b.time)
				return d - c
			})
		},
		async getExerciseList() {
			const exerciseList = []
			let queryParams = {}
			queryParams["page"] = 1
			queryParams["limit"] = 9999999
			queryParams["f_petId"] = this.getActivePet.id
			queryParams["f_dateStartsAt"] = this.formatDate(this.dateStartsAt)
			queryParams["f_dateEndsAt"] = this.formatDate(this.dateEndsAt)

			await exerciseService.getExercise(queryParams).then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					for (const exercise of res.data.data) {
						const e = {
							time: exercise.exerciseDate,
							img: `${require("@/assets/images/_shared/health-data.png")}`,
							title: "Exercise",
							class: "is-exercise",
							hasAction: false,
							hasSlot: true,
							data: {
								offLeash: this.timeConvert(exercise.offLeash),
								onLeash: this.timeConvert(exercise.onLeash),
							},
						}
						exerciseList.push(e)
					}
				}
			})

			return exerciseList
		},
		timeConvert(mins) {
			let hours = mins / 60
			let tempHours = Math.floor(hours)
			let minutes = (hours - tempHours) * 60
			let tempMinutes = Math.round(minutes)

			if (tempHours === 0) {
				return tempMinutes > 1 ? `${tempMinutes} minutes` : `${tempMinutes} minute`
			} else if (tempMinutes === 0) {
				return tempHours > 1 ? `${tempHours} hours` : `${tempHours} hour`
			} else {
				tempMinutes = tempMinutes > 1 ? `${tempMinutes} minutes` : `${tempMinutes} minute`
				tempHours = tempHours > 1 ? `${tempHours} hours ` : `${tempHours} hour `
				return tempHours + tempMinutes
			}
		},
		async getTreatmentList() {
			const treatmentList = []
			let queryParams = {}
			queryParams["page"] = 1
			queryParams["limit"] = 9999999
			queryParams["f_dateStartsAt"] = this.formatDate(this.dateStartsAt)
			queryParams["f_dateEndsAt"] = this.formatDate(this.dateEndsAt)

			await treatmentService.getTreatments(this.getActivePet.id, queryParams).then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					for (const treatment of res.data.data) {
						const e = {
							time: treatment.dateApplied,
							img: `${require("@/assets/images/_shared/treatment.png")}`,
							title: "Treatment",
							class: "is-treatment",
							hasAction: false,
							hasSlot: true,
							data: treatment,
						}
						treatmentList.push(e)
					}
				}
			})
			return treatmentList
		},
		async getReminderList(status) {
			try {
				const reminderList = []
				let queryParams = {}
				queryParams["f_petId"] = this.getActivePet.id
				queryParams["f_startDate"] = this.formatDate(this.dateStartsAt)
				queryParams["f_endDate"] = this.formatDate(this.dateEndsAt)
				queryParams["f_status"] = status

				await reminderService.getReminderLists(queryParams).then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						for (const reminder of res.data.data) {
							const e = {
								time: reminder.schedule,
								img: `${require("@/assets/images/_shared/gen-info.png")}`,
								title: "Reminder",
								class: "is-reminder",
								hasAction: false,
								hasSlot: true,
								data: reminder,
								hasSlotTime: true,
							}
							reminderList.push(e)
						}
					}
				})
				return reminderList
			} catch (error) {
			}
		},

		async getGeneralInfoList() {
			const genInfoList = []
			let queryParams = {}
			queryParams["f_dateStartsAt"] = this.formatDate(this.dateStartsAt)
			queryParams["f_dateEndsAt"] = this.formatDate(this.dateEndsAt)
			queryParams["f_notificationTypeCode"] = "GEN_INFO"

			await notificationService.getNotification(this.getActivePet.id, queryParams).then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					for (const gen of res.data.data) {
						const e = {
							time: gen.schedule,
							img: this.getActivePet.imageUrl ? this.getActivePet.imageUrl : "",
							title: "Age Milestone",
							content: gen.title,
							class: "is-birthdate",
						}

						genInfoList.push(e)
					}
				}
			})

			return genInfoList
		},
	},
}
